import {
  DoubleSide,
  Group,
  MeshBasicMaterial,
  MathUtils,
  ShaderMaterial,
  Vector2,
} from "three";
import curation from "../../data/curation";
import content from "../../data/content";
import Objkt from "./objkt";
import Title from "./title";
import { TWO_PI } from "../../utils/math";
import { EventEmitter } from "eventemitter3";
import { vertexShader, fragmentShader } from "./shader.glsl";
import renderTargets from "../../render-targets";
import gsap from "gsap/gsap-core";

const curationData = curation.curation;
const contentData = content[curation.id];

export default class Objkts extends EventEmitter {
  constructor(gui) {
    super();
    this.gui = gui.addFolder("objkts");
    this.gui.open();
    this.gui.add(this, "randomise");
    this.gui.add(this, "export");

    this.group = new Group();

    this.titleMaterial = new MeshBasicMaterial({
      side: DoubleSide,
      transparent: true,
      opacity: 0,
      color: 0xffffff,
    });

    this.subtitleMaterial = new MeshBasicMaterial({
      side: DoubleSide,
      transparent: true,
      opacity: 0,
      color: 0x050505,
    });

    this.hiddenMaterial = new MeshBasicMaterial({
      side: DoubleSide,
      transparent: true,
      opacity: 0,
      color: 0x050505,
    });

    this.title = new Title(
      this.gui,
      curationData,
      this.titleMaterial,
      this.subtitleMaterial,
      content[curation.id]
    );
    this.group.add(this.title.group);

    this.objkts = [];
    this.objktMaterial = new ShaderMaterial({
      side: DoubleSide,
      uniforms: {
        transition: {
          value: 0,
        },
        resolution: {
          value: new Vector2(1, 1),
        },
        backgroundTexture: {
          value: renderTargets.background.texture,
        },
      },
      vertexShader,
      fragmentShader,
    });
    for (let i = 0; i < curationData.artists.length; i++) {
      // if (i > 0) break;
      const objkt = new Objkt(
        this.gui,
        curationData.artists[i],
        this.objktMaterial,
        this.hiddenMaterial
      );
      objkt.on("click", this.onClick);
      objkt.group.position.fromArray(contentData.positions[i]);
      this.group.add(objkt.group);
      this.objkts.push(objkt);
    }
  }

  animate() {
    gsap.to(this.titleMaterial, 2, {
      opacity: 1,
      delay: 0.5,
    });
    gsap.to(this.subtitleMaterial, 2, {
      opacity: 1,
      delay: 0.5,
    });

    const objktDelay = 2.5;
    gsap.to(this.hiddenMaterial, 2, {
      opacity: 1,
      delay: objktDelay,
    });
    gsap.to(this.objktMaterial.uniforms.transition, 2, {
      opacity: 1,
      delay: objktDelay,
    });

    for (let i = 0; i < this.objkts.length; i++) {
      this.objkts[i].animate(objktDelay + MathUtils.randFloat(0, 0.4));
    }
  }

  onClick = (objktID) => {
    this.emit("click", objktID);
  };

  randomise = () => {
    for (let i = 0; i < this.objkts.length; i++) {
      const theta = i * (TWO_PI / curationData.artists.length);
      const radius = MathUtils.randFloat(12, 15);
      const x = radius * Math.cos(theta);
      const y = radius * Math.sin(theta);
      const z = MathUtils.randFloat(-5, 5);
      this.objkts[i].group.position.set(x, y, z);
    }
  };

  export = () => {
    const data = [];
    for (let i = 0; i < this.objkts.length; i++) {
      data.push(this.objkts[i].group.position.toArray());
    }
    window.prompt("Copy", JSON.stringify(data, null, 2));
  };

  resize(width, height) {
    this.objktMaterial.uniforms.resolution.value.set(width, height);
  }

  update = (delta) => {
    for (let i = 0; i < this.objkts.length; i++) {
      this.objkts[i].update(delta);
    }
  };
}
